import React from "react";
import ReactDOM from "react-dom/client";
import App from "./App";
// import * as serviceWorkerRegistration from './serviceWorkerRegistration'; 

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<App />);

// Change unregister() to register() to enable service worker
// serviceWorkerRegistration.register();
